export const SCHEDULE_START_HOUR = 5;
export const SCHEDULE_END_HOUR = 24;
export const SCHEDULE_TOTAL_HOURS = SCHEDULE_END_HOUR - SCHEDULE_START_HOUR;
export const MINUTES_PER_HOUR = 60;

export const SCHEDULE_HOUR_HEIGHT = 30;
export const SCHEDULE_HOUR_HEIGHT_MOBILE = 48;
export const SCHEDULE_HOUR_LINE_THICKNESS = 1;
export const SCHEDULE_HEADER_HEIGHT = 34;
export const SCHEDULE_TIME_COLUMN_WIDTH = 92;
export const SCHEDULE_TIME_COLUMN_MOBILE_WIDTH = 48;
export const SCHEDULE_BLOCK_MIN_HEIGHT = 18;

export const SCHEDULE_HOUR_LABEL_FORMAT = 'h:00 A';
export const SCHEDULE_HOUR_LABEL_MOBILE_FORMAT = 'h:00';
export const SCHEDULE_BLOCK_TIME_FORMAT = 'h:mm';
export const SCHEDULE_BLOCK_RANGE_TIME_FORMAT = 'h';
export const SCHEDULE_TOOLTIP_TIME_FORMAT = 'h:mm A';

export const WEEKLY_SCHEDULE_DAYS = [
  { key: 'MONDAY', label: 'Monday', shortLabel: 'Mon' },
  { key: 'TUESDAY', label: 'Tuesday', shortLabel: 'Tue' },
  { key: 'WEDNESDAY', label: 'Wednesday', shortLabel: 'Wed' },
  { key: 'THURSDAY', label: 'Thursday', shortLabel: 'Thu' },
  { key: 'FRIDAY', label: 'Friday', shortLabel: 'Fri' },
  { key: 'SATURDAY', label: 'Saturday', shortLabel: 'Sat' },
  { key: 'SUNDAY', label: 'Sunday', shortLabel: 'Sun' },
] as const;
